module.exports = __webpack_public_path__ + "create/static/media/avatar_Laura.e2f40896.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/CreateExperience/Institucional/avatar_Laura.png
// module id = 474
// module chunks = 37